<template>
  <div class="overlay-full-screen" ref="overlay">
    <div class="overlay-full-screen__background" />
    <div class="overlay-full-screen__content">
      <slot />
    </div>
  </div>
</template>

<script setup>
import { gsap } from 'gsap'

const emit = defineEmits(['animation-update', 'animation-reverse-complete'])

const props = defineProps({
  show: Boolean,
})

const overlay = ref(null)
const tl = ref(null)

watch(
  () => props.show,
  async (show) => {
    if (!tl.value?.isActive()) {
      tl.value = show ? animateIn() : animateOut()
      await tl.value.play()
    }
  },
)

// Animazioni
const animateIn = (params) => {
  const parent = overlay.value
  const background = parent.querySelector('.overlay-full-screen__background')
  const content = parent.querySelector('.overlay-full-screen__content')

  const tl = gsap.timeline({
    paused: true,
    onStart: () => {
      parent.style.pointerEvents = 'auto'
    },
    onUpdate: () => {
      emit('animation-update', tl.progress())
    },
    onComplete: () => {
      lenis.stop()
      tl.kill()
    },
    ...params,
  })
  tl.set(parent, { autoAlpha: 1 })
  tl.to(background, {
    scaleX: 1,
  })
  tl.to(content, {
    opacity: 1,
  })
  return tl
}

const animateOut = (params) => {
  const parent = overlay.value
  const background = parent.querySelector('.overlay-full-screen__background')
  const content = parent.querySelector('.overlay-full-screen__content')

  const tl = gsap.timeline({
    paused: true,
    onUpdate: () => {
      emit('animation-update', tl.progress())
    },
    onComplete: () => {
      lenis.start()
      parent.style.pointerEvents = 'none'
      tl.kill()
    },
    ...params,
  })

  tl.to(content, {
    opacity: 0,
  })
  tl.to(background, {
    scaleX: 0,
  })
  return tl
}
defineExpose({
  animateIn,
  animateOut,
})
</script>

<script>
export default {
  name: 'WidgetOverlayFullScreen',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
